export const STATS = 'OBS::STATS';
